import AutoButtonsField from "./AutoButtonsField.mjs";
import {Button, ButtonGroup} from "reactstrap";
import CheckedIcon from "../../media/images/CheckedIcon.mjs";
import UncheckedIcon from "../../media/images/UncheckedIcon.mjs";

const AutoCheckboxField = class extends AutoButtonsField {
	constructor(props) {
		super(props);
		this.checkForValidValues = this.checkForValidValues.bind(this);
	}

	componentDidMount() {
		super.componentDidMount();
		this.checkForValidValues();
	}

	checkForValidValues() {
		let v = this.state.value;
		if ( ! v ) return;
		const wasArray = Array.isArray(v);
		if ( ! wasArray) v = [v];
		const prevLength = v.length;
		const opts = this.state.options || [];
		v = v.filter( x => opts.find( o => o.value === x ) );
		if ( v.length === prevLength ) return;
		this.setValue(wasArray ? v : v[0] );
	}

	renderField() {
		let vs = this.state.value || [];
		const multi= (this.state.options.length > 1);
		if ( multi ) {
			if ( vs && ! Array.isArray(vs)) vs = [vs];
		} else {
			if ( Array.isArray(vs) ) vs = vs[0];
		}
		return(
			<ButtonGroup
				vertical={ this.state.options.length > 3 }
				className={"btn-icon AutoButtons"}
			>
				{ this.state.options.map( (b,i) => {
					const active = multi ? vs.includes(b.value) : vs === b.value;
					return (
						<Button
							key={String(i)+this.state.value}
							active={ active }
							onClick={ ()=>{
								if ( multi ) {
									if ( vs.includes(b.value) ) {
										const x = vs.filter( v => v !== b.value );
										this.setValue( x.length > 0 ? x : undefined );
									} else {
										vs.push(b.value);
										this.setValue(vs);
									}
								} else {
									if ( vs !== b.value ) {
										this.setValue(b.value);
									} else {
										this.setValue();
									}
								}
							}}
						>
							<i>
								{ active ? <CheckedIcon /> : <UncheckedIcon /> }
							</i>
							<b>{b.label}</b>
						</Button>
					)
				})}
			</ButtonGroup>
		)
	}
}

export default AutoCheckboxField;
